// extracted by mini-css-extract-plugin
export default {"container":"Container_container__MM274","widthMedium":"Container_widthMedium__nXHvt","widthSmall":"Container_widthSmall__RF-r7"};